import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../Routes/AuthProvider";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { useLocation, useNavigate } from "react-router-dom";
import { getInsuranceCategory, GetPlan, } from "../../Services/InsuranceApi";
import { TravelPolicies } from "../../Services/API";

const ModifySerchResult = () => {
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  // Travel Purpose
  const [travelPurpose, setTravelPurpose] = useState("BusinessTravel");

  // Category
  const [InsuranceCategory, setInsuranceCategory] = useState([
    {
      "id": "296a9n2f-3071-4395-g416-31d60fdf0d4e",
      "name": "Domestic",
      "description": "Domestic",
      "additionalProperties": {}
    },
    {
      "id": "296a9c2f-3071-4395-a416-31d60fdf0d4d",
      "name": "Including USA and CANADA (Worldwide)",
      "description": "Including USA and CANADA (Worldwide)",
      "additionalProperties": {}
    },
    {
      "id": "9de85e1d-3a05-4ae1-aa03-87cc5fe41640",
      "name": "Excluding USA & Canada",
      "description": "Excluding USA & Canada",
      "additionalProperties": {}
    }
  ]);
  const [selectedCountry, setSelectedCountry] = useState("");

  // Travel Type
  const [travelType, setTravelType] = useState("");

  // Dates
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [travelDays, setTravelDays] = useState(0);

  // Traveller Dropdown
  const [showDropdown, setShowDropdown] = useState(false);

  // Traveller Quantity
  const [quantity, setQuantity] = useState(1);

  // Travellers
  const [travellers, setTravellers] = useState([
    { age: "" },
  ]);

  const [tripType, setTripType] = useState("Domestic");
  const [policies, setPolicies] = useState([]);

  const UpdatetripType = (country) => {
    //alert(country);
    let newTripType = "";
    if (country === "296a9n2f-3071-4395-g416-31d60fdf0d4e") {
      newTripType = "Domestic";
    } else {
      newTripType = "International";
    }
    setTripType(newTripType);
    //alert(newTripType);
  };

  const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
  const userId = emulateCorporateCode || corporateId;
  const CorpTravellerUserId = localStorage.getItem("selectedUserId");
  const CorpTraveller = CorpTravellerUserId ?? userName;
  useEffect(() => {
    //debugger;
    if (!userName || !tripType || !userId || userId === "null" || userId === "undefined") return;
    const getTravelPolicies = async () => {
      try {
        const response = await TravelPolicies({
          UserName: CorpTraveller,
          ProductType: "Insurance",
          CorporateCode: userId,
          TravelType: tripType
        });

        setPolicies(response);
        //console.log("getTravelPolicies", response);
      } catch (error) {
        console.error(error);
      }
    };
    getTravelPolicies();
  }, [userName, userId, tripType]);

  // useEffect(() => {
  //   const fetchInsuranceCategory = async () => {
  //     try {
  //       const data = await getInsuranceCategory();
  //       setInsuranceCategory(data);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   fetchInsuranceCategory();
  // }, []);


  // ==============================
  // Calculate Travel Days
  // ==============================
  const calculateDays = () => {
    const start = $("#departureDate").datepicker("getDate");
    const end = $("#returnDate").datepicker("getDate");

    if (start && end) {
      const diffTime = end - start;

      const diffDays =
        Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      setTravelDays(diffDays > 0 ? diffDays : 0);
    } else {
      setTravelDays(0);
    }
  };

  // ==============================
  // Departure Datepicker
  // ==============================
  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",

      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();

          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },

      onSelect: function (dateText) {
        setStartDate(dateText);

        const date = $(this).datepicker("getDate");

        const day = ("0" + date.getDate()).slice(-2);

        const month = date.toLocaleString("default", {
          month: "short",
        });

        const year = date.getFullYear();

        const dayName = date.toLocaleDateString(
          "default",
          {
            weekday: "long",
          }
        );

        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);

        calculateDays();
      },
    });
  }, []);

  // ==============================
  // Return Datepicker
  // ==============================
  useEffect(() => {
    $("#returnDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",

      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();

          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },

      onSelect: function (dateText) {
        setEndDate(dateText);

        const date = $(this).datepicker("getDate");

        const day = ("0" + date.getDate()).slice(-2);

        const month = date.toLocaleString("default", {
          month: "short",
        });

        const year = date.getFullYear();

        const dayName = date.toLocaleDateString(
          "default",
          {
            weekday: "long",
          }
        );

        $("#ret_dayNum").text(day);
        $("#ret_monthYear").text(`${month}-${year}`);
        $("#ret_dayName").text(dayName);

        calculateDays();
      },
    });
  }, []);

  // ==============================
  // Set Min Return Date
  // ==============================
  useEffect(() => {
    if (startDate) {
      const [d, m, y] = startDate.split("/");

      const minD = new Date(`${y}-${m}-${d}`);

      $("#returnDate").datepicker(
        "option",
        "minDate",
        minD
      );
    }
  }, [startDate]);

  // ==============================
  // Increase Traveller
  // ==============================
  const increaseQty = () => {
    if (quantity < 4) {
      setQuantity((prev) => prev + 1);

      setTravellers((prev) => [
        ...prev,
        { age: "" },
      ]);
    }
  };

  // ==============================
  // Decrease Traveller
  // ==============================
  const decreaseQty = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);

      setTravellers((prev) =>
        prev.slice(0, -1)
      );
    }
  };

  // ==============================
  // Traveller Age Change
  // ==============================
  const handleAgeChange = (index, value) => {
    const updatedTravellers = [...travellers];

    updatedTravellers[index].age = value;

    setTravellers(updatedTravellers);
  };

  // ==============================
  // Search Insurance
  // ==============================
  const [errors, setErrors] = useState({});

  const handleInsuranceResult = async () => {
    const start = $("#departureDate").datepicker("getDate");
    const end = $("#returnDate").datepicker("getDate");

    let newErrors = {};

    if (!selectedCountry)
      newErrors.selectedCountry = "Select country";

    if (!travelType)
      newErrors.travelType = "Select travel type";

    if (!start)
      newErrors.start = "Select start date";

    if (!end)
      newErrors.end = "Select end date";

    if (travellers.some((t) => !t.age))
      newErrors.emptyAge = "Enter all ages";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const formatDate = (date) => {
      const d = new Date(date);

      return `${String(d.getDate()).padStart(
        2,
        "0"
      )}/${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}/${d.getFullYear()}`;
    };
    const ages = travellers.map((t) =>
      Number(t.age)
    );

    const durations = ages.map(() =>
      Number(travelDays)
    );

    const selectedCountryName =
      InsuranceCategory?.find(
        (item) => String(item.id) === String(selectedCountry)
      )?.name || "";

    const CorpTraveller = userId ?? userName;
    const CorpCode = emulateCorporateCode ?? corporateId;
    const is_Emulate = !!emulateCorporateCode;
    const requestBody = {
      travelPurpose: Number(travelPurpose),
      loggedInUserId: userName,
      corporateTraveller: CorpTraveller,
      corporateCode: CorpCode,
      isEmulated: is_Emulate,
      tripType: tripType,
      key:
        localStorage.getItem("insuranceKey") || "",
      clientCode: "BerryJourneys",
      trips: {
        startDate: formatDate(start),
        endDate: formatDate(end),
        duration: durations, // <-- changed
        age: ages,
        travelType: travelType,
        category: selectedCountry,
        selectedCountryName,
        partnerId: "00004448-0000-0000-0000-000000000000",
      },
    };

    try {
      console.log(
        "GET PLAN REQUEST:",
        requestBody
      );

      const response = await GetPlan(
        requestBody
      );



      if (!response) {
        alert("No plans found.");
        return;
      }

      // Save Key
      const insuranceKey =
        response?.key ||
        response?.data?.key ||
        response?.result?.key ||
        "";

      if (insuranceKey) {
        localStorage.setItem(
          "insuranceKey",
          insuranceKey
        );
      }

      // Save Reference No if available
      const referenceNo =
        response?.referenceNo ||
        response?.data?.referenceNo ||
        response?.result?.referenceNo ||
        "";

      if (referenceNo) {
        localStorage.setItem(
          "insuranceReferenceNo",
          referenceNo
        );
      }

      console.log(
        "Saved Key:",
        insuranceKey
      );

      console.log(
        "Saved Reference No:",
        referenceNo
      );

      const queryParams =
        new URLSearchParams({
          travelType: travelPurpose,
          travelCategory: travelType,
          selectedCountry,
          startDate: formatDate(start),
          endDate: formatDate(end),
          travellers: quantity,
          ages: travellers
            .map((t) => t.age)
            .join(","),
        });



      navigate(
        `/insurance/results?${queryParams.toString()}`,
        {
          state: {
            plans:
              response?.externalCPPlanRootDto ||
              response?.plans ||
              [],

            searchData: requestBody,
            insuranceKey,
            insuranceReferenceNo: referenceNo,
          },
        }

      );
      window.location.reload();
    } catch (error) {
      console.error(
        "GetPlan API Error:",
        error
      );
      console.log(
        "Traveller Ages:",
        travellers.map((t) => t.age)
      );

      console.log(
        "Request Body:",
        JSON.stringify(requestBody, null, 2)
      );
      console.error(
        "API Error Response:",
        error?.response?.data
      );

      alert(
        error?.response?.data?.message ||
        "Unable to fetch insurance plans."
      );
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const travelTypeModeParam =
      params.get("travelType") || "1";

    const selectedCountryParam =
      params.get("selectedCountry") || "";


    const travelTypeParam =
      params.get("travelCategory") ||
      location.state?.searchData?.trips?.travelType ||
      "Business";
    setTravelType(travelTypeParam);

    const startDateParam =
      params.get("startDate") || "";

    const endDateParam =
      params.get("endDate") || "";

    const travellerCount = Number(
      params.get("travellers") || 1
    );




    // Get ages from URL first
    let ages = params.get("ages")
      ? params.get("ages").split(",")
      : [];

    // Fallback to state data
    if (
      ages.length === 0 &&
      location.state?.searchData?.trips?.age
    ) {
      ages =
        location.state.searchData.trips.age;
    }



    setTravelPurpose(travelTypeModeParam);
    setSelectedCountry(selectedCountryParam);
    setTravelType(travelTypeParam);
    setQuantity(travellerCount);

    setTravellers(
      Array.from(
        { length: travellerCount },
        (_, index) => ({
          age: ages[index] || "",
        })
      )
    );

    if (startDateParam) {
      setStartDate(startDateParam);

      $("#departureDate").val(startDateParam);

      const [d, m, y] =
        startDateParam.split("/");

      const date = new Date(
        `${y}-${m}-${d}`
      );

      $("#dep_dayNum").text(
        ("0" + date.getDate()).slice(-2)
      );

      $("#dep_monthYear").text(
        `${date.toLocaleString("default", {
          month: "short",
        })}-${date.getFullYear()}`
      );

      $("#dep_dayName").text(
        date.toLocaleDateString(
          "default",
          {
            weekday: "long",
          }
        )
      );
    }

    if (endDateParam) {
      setEndDate(endDateParam);

      $("#returnDate").val(endDateParam);

      const [d, m, y] =
        endDateParam.split("/");

      const date = new Date(
        `${y}-${m}-${d}`
      );

      $("#ret_dayNum").text(
        ("0" + date.getDate()).slice(-2)
      );

      $("#ret_monthYear").text(
        `${date.toLocaleString("default", {
          month: "short",
        })}-${date.getFullYear()}`
      );

      $("#ret_dayName").text(
        date.toLocaleDateString(
          "default",
          {
            weekday: "long",
          }
        )
      );
    }

    if (
      startDateParam &&
      endDateParam
    ) {
      const [sd, sm, sy] =
        startDateParam.split("/");

      const [ed, em, ey] =
        endDateParam.split("/");

      const start = new Date(
        `${sy}-${sm}-${sd}`
      );

      const end = new Date(
        `${ey}-${em}-${ed}`
      );

      const diff =
        Math.ceil(
          (end - start) /
          (1000 * 60 * 60 * 24)
        ) + 1;

      setTravelDays(diff);
    }
  }, [location.search]);


  return (
    <>
      <div className="insu_serch">
        <div className="row">
          <div className="col-md-6 col-lg-6">
            <div className="d-flex">
              {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isBusinessTravelEnabled === true && (
                <div className="travel_mode">
                  <div className="form-check form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="travelPurpose"
                      value="1"
                      checked={travelPurpose === "1"}
                      onChange={(e) =>
                        setTravelPurpose(
                          e.target.value
                        )
                      }
                    />

                    <label className="form-check-label">
                      Business Travel
                    </label>
                  </div>
                </div>
              )}
              {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isPersonalTravelEnabled === true && (
                <div className="travel_mode">
                  <div className="form-check form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="travelPurpose"
                      value="2"
                      checked={travelPurpose === "2"}
                      onChange={(e) =>
                        setTravelPurpose(
                          e.target.value
                        )
                      }
                    />

                    <label className="form-check-label">
                      Personal Travel
                    </label>
                  </div>
                </div>
              )}
              {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isGuestTravelEnabled === true &&
                ["TMC Operations"].some(role => roles?.includes(role)) && (
                  <div className="travel_mode">
                    <div className="form-check form-check-custom form-check-solid">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="travelPurpose"
                        value="3"
                        checked={travelPurpose === "3"}
                        onChange={(e) =>
                          setTravelPurpose(
                            e.target.value
                          )
                        }
                      />

                      <label className="form-check-label">
                        Guest Travel
                      </label>
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div className="col-md-6 col-lg-6">
            <div className="displ_plan"></div>
          </div>
        </div>

        {/* FORM */}

        <div className='form_ful Modfy'>
          {/* Travelling To */}
          <div className="insurnce_clo_1 trivl">
            <div className="visa_icon_img">
              <img
                className="bus_ic"
                src="/assets/images/travel.png"
                alt="travel"
              />
            </div>
            <div className="bus_icon">
              <p>Travelling To</p>
              <select
                className={`selct_control ${errors.selectedCountry ? "border-danger" : ""
                  }`}
                value={selectedCountry}
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  setErrors((prev) => ({
                    ...prev,
                    selectedCountry: "",
                  }));
                  UpdatetripType(e.target.value)
                }
                }
              >
                <option value="">Select ..</option>
                <option value="296a9n2f-3071-4395-g416-31d60fdf0d4e">
                  Domestic
                </option>

                <option value="296a9c2f-3071-4395-a416-31d60fdf0d4d">
                  Including USA and CANADA (Worldwide)
                </option>

                <option value="9de85e1d-3a05-4ae1-aa03-87cc5fe41640">
                  Excluding USA & Canada
                </option>
              </select>
              {errors.selectedCountry && (
                <p className="error">
                  {errors.selectedCountry}
                </p>
              )}
            </div>
          </div>

          {/* Travel Type */}
          <div className="insurnce_clo_1 trivl">
            <div className="visa_icon_img">
              <img
                className="bus_ic"
                src="/assets/images/traveller.png"
                alt="traveller"
              />
            </div>

            <div className="bus_icon">
              <p>Travel Type</p>

              <select
                className="selct_control"
                value={travelType}
                onChange={(e) =>
                  setTravelType(
                    e.target.value
                  )
                }
              >
                <option value="">
                  Select
                </option>

                <option value="Leisure">
                  Leisure
                </option>

                <option value="Business">
                  Business
                </option>

                <option value="Student">
                  Student
                </option>
              </select>
              {errors.travelType && <p className="error">{errors.travelType}</p>}
            </div>
          </div>

          {/* Start Date */}
          <div className="insurnce_clo_1">
            <div className="visa_icon_img">
              <img
                className="bus_ic"
                src="/assets/images/date.png"
                alt="date"
              />
            </div>

            <div className="bus_icon">
              <p>Start Date</p>

              <div
                className="dest_nam_i"
                id="dateDisplay"
                onClick={() =>
                  $("#departureDate").datepicker(
                    "show"
                  )
                }
                style={{
                  cursor: "pointer",
                }}
              >
                <span
                  id="dep_dayNum"
                  style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                  }}
                >
                  DD
                </span>{" "}
                <span
                  id="dep_monthYear"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  MM-YYYY
                </span>

                <br />

                <span id="dep_dayName">
                  Day
                </span>

                <input
                  type="text"
                  id="departureDate"
                  style={{
                    position: "absolute",
                    left: "-9999px",
                  }}
                  readOnly
                />
              </div>
              {errors.start && (<p className="error">{errors.start}</p>)}
            </div>
          </div>

          {/* End Date */}
          <div className="insurnce_clo_1">
            <div className="visa_icon_img">
              <img
                className="bus_ic"
                src="/assets/images/date.png"
                alt="date"
              />
            </div>

            <div className="bus_icon">
              <p>End Date</p>

              <div
                className="dest_nam_i"
                id="dateDisplay2"
                onClick={() =>
                  $("#returnDate").datepicker(
                    "show"
                  )
                }
                style={{
                  cursor: "pointer",
                }}
              >
                <span
                  id="ret_dayNum"
                  style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                  }}
                >
                  DD
                </span>{" "}
                <span
                  id="ret_monthYear"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  MM-YYYY
                </span>

                <br />

                <span id="ret_dayName">
                  Day
                </span>

                <input
                  type="text"
                  id="returnDate"
                  style={{
                    position: "absolute",
                    left: "-9999px",
                  }}
                  readOnly
                />
              </div>
            </div>
            {errors.end && (<p className="error">{errors.end}</p>)}
          </div>

          {/* Travel Days */}
          <div className="insurnce_clo_1">
            <div className="visa_icon_img">
              <img
                className="bus_ic"
                src="/assets/images/days.png"
                alt="days"
              />
            </div>

            <div className="bus_icon">
              <p>Travel Days</p>

              <div className="travl_days">
                {travelDays}
              </div>

              <p>Days</p>
            </div>
          </div>

          {/* Travellers */}
          <div
            className="insurnce_clo_1 trivl"
            id="showSelectInsure"
          >
            <div className="visa_icon_img">
              <img
                className="bus_ic"
                src="/assets/images/guest.png"
                alt="guest"
              />
            </div>

            <div className="bus_icon">
              <p>Travellers</p>

              <div className="p-0">
                <div
                  className="travl_from"
                  onClick={() =>
                    setShowDropdown(
                      !showDropdown
                    )
                  }
                >
                  Traveller{" "}
                  <img
                    src="/assets/images/down.png"
                    className="down"
                    alt="down"
                  />
                </div>

                <p>{quantity} Pax</p>
                {errors.emptyAge && (<p className="error"> {errors.emptyAge}  </p>)}
              </div>

              {/* Dropdown */}
              {showDropdown && (
                <div
                  className="insurance dropdown_passenger_in"
                  id="toggle_showSelectInsure"
                >
                  <div className="traveller-calulate-persons">
                    <div className="passengers">
                      <div className="passengers-types">
                        {/* Plus Minus */}
                        <div className="d-flex align-items-center plusMinus mb-3">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={
                              decreaseQty
                            }
                            disabled={
                              quantity === 1
                            }
                          >
                            -
                          </button>

                          <input
                            type="number"
                            className="form-controls text-center"
                            value={quantity}
                            readOnly
                            style={{
                              width: "70px",
                            }}
                          />

                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={
                              increaseQty
                            }
                            disabled={
                              quantity === 4
                            }
                          >
                            +
                          </button>
                        </div>

                        {/* Dynamic Travellers */}
                        {travellers.map(
                          (
                            traveller,
                            index
                          ) => (
                            <div
                              className="passengers-type mb-2"
                              key={index}
                            >
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="text">
                                  <div className="type-label">
                                    <p className="mb-0">
                                      Traveller{" "}
                                      {index +
                                        1}
                                    </p>
                                  </div>
                                </div>

                                <div className="button-set">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Age"
                                    min="1"
                                    max="99"
                                    value={traveller?.age ?? ""}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (value.length > 2) return;
                                      if (value && Number(value) > 99) return;

                                      handleAgeChange(index, value);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>

                    <div className="col-md-12 d-flex justify-content-end mt-3">
                      <button
                        className="done_selct btn btn-primary"
                        onClick={() =>
                          setShowDropdown(
                            false
                          )
                        }
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Search */}
          <div className="Rooms_Guests_Serch">
            <button
              type="button"
              className="Serch"
              onClick={
                handleInsuranceResult
              }
            >
              Search
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default ModifySerchResult;